import React from 'react';
import { Link } from 'react-router-dom';
import { ICON_REPORT, ICON_PEOPLE, ICON_CONFIG, ICON_DASHBOARD, ICON_TABLE, ICON_EYE, ICON_CALENDAR } from '../extras/icons';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { collapseMenuAction, expandMenuAction } from '../../actions/systemActions';
import { INHIBICIONES_LISTAR, LICENCIAS_LISTAR, NIVELES_MODIFICAR, OFIJUS_LISTAR, RECUSACIONES_LISTAR, TURNOS_LISTAR, UNIDADES_LISTAR, USUARIOS_LISTAR } from '../../data/objects';

//Authorities
import Authorities from '../../services/AuthoritiesService';
import { PROFILE_SISTEMAS, PROFILE_OGA } from '../../data/profiles';
//Función principal
const SideBar = () => {
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const expandMenu = useSelector( state => state.system.expandMenu );
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el botón de expandir
    const handleExpand = () => {
        //Ejecuto acción
        if(expandMenu){
            //Collapse
            dispatch( collapseMenuAction() );
        }else{
            //Expand
            dispatch( expandMenuAction() );
        }
    }
    //Renderizo
    return (
        <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${expandMenu ? '' : 'toggled'}`} id="accordionSidebar">

            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
                <div className="sidebar-brand-icon">
                    <img alt="logo" src="/img/logo-oga-mini.png" className="img-fluid" style={{ maxHeight: '36px' }}/>
                </div>
                <div className="sidebar-brand-text mx-3">OGA Web <sup>2</sup></div>
            </Link>

            <hr className="sidebar-divider my-0" />

            <li className="nav-item">
                <Link to="/" className="nav-link">
                    <ICON_DASHBOARD className="fa-fw" />
                    <span>Escritorio</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link to="/audiencias" className="nav-link">
                    <ICON_EYE className="fa-fw" />
                    <span>Audiencias</span>
                </Link>
            </li>

            {
                authUser && (authUser.perfil.id === PROFILE_SISTEMAS || authUser.perfil.id === PROFILE_OGA) ? (
                    <li className="nav-item">
                        <Link to="/audiencias/calendario" className="nav-link">
                            <ICON_CALENDAR className="fa-fw" />
                            <span>Calendario</span>
                        </Link>
                    </li>
                ) : null
            }

            {
                authorities ? (
                    <React.Fragment>
                        <hr className="sidebar-divider" />

                        {
                            Authorities.hasInterfaces(authorities) || Authorities.hasReports(authorities, authUser) ? (
                                <div className="sidebar-heading">
                                    Interface
                                </div>
                            ) : null
                        }
                        

                        {
                            Authorities.hasPersons(authorities) ? (
                                <li className="nav-item">
                                    <a className="nav-link collapsed" href="!#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                        <ICON_PEOPLE className="fa-fw" />
                                        <span>Personas</span>
                                    </a>
                                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                                        <div className="bg-white py-2 collapse-inner rounded">
                                            <Link className="collapse-item" to="/personas/jueces">
                                                Jueces
                                            </Link>
                                            <Link className="collapse-item" to="/personas/funcionarios">
                                                Funcionarios
                                            </Link>
                                        </div>
                                    </div>
                                </li>
                            ) : null
                        }
                        
                        {
                            Authorities.hasUtilities(authorities) ? (
                                <li className="nav-item">
                                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
                                        <i className="fas fa-fw fa-wrench"></i>
                                        <span>Utilidades</span>
                                    </a>
                                    <div id="collapseUtilities" className="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
                                        <div className="bg-white py-2 collapse-inner rounded">
                                            <h6 className="collapse-header">Jueces:</h6>
                                            {
                                                Authorities.hasPermission(authorities, INHIBICIONES_LISTAR) ? (
                                                    <Link className="collapse-item" to="/utilidades/inhibiciones">
                                                        Inhibiciones
                                                    </Link>
                                                ) : null
                                            }

                                            {
                                                Authorities.hasPermission(authorities, TURNOS_LISTAR) ? (
                                                    <Link className="collapse-item" to="/utilidades/turnos">
                                                        Turnos
                                                    </Link>
                                                ) : null
                                            }
                                            
                                            {
                                                Authorities.hasPermission(authorities, RECUSACIONES_LISTAR) ? (
                                                    <Link className="collapse-item" to="/utilidades/recusaciones">
                                                        Recusaciones
                                                    </Link>
                                                ) : null
                                            }
                                            
                                            
                                            <h6 className="collapse-header">Audiencistas:</h6>
                                            {
                                                Authorities.hasPermission(authorities, LICENCIAS_LISTAR) ? (
                                                    <Link className="collapse-item" to="/utilidades/licencias">
                                                        Licencias
                                                    </Link>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </li>
                            ) : null
                        }
                        
                        {
                            Authorities.hasReports(authorities, authUser) ? (
                                <li className="nav-item">
                                    <Link className="nav-link" to="/reportes">
                                        <ICON_REPORT className="fa-fw" />
                                        <span>Reportes</span>
                                    </Link>
                                </li>
                            ) : null
                        }

                        

                        {
                            Authorities.hasConfig(authorities) ? (
                                <React.Fragment>
                                    <hr className="sidebar-divider" />

                                    <div className="sidebar-heading">
                                        Config
                                    </div>
                                </React.Fragment>
                            ) : null
                        }

                        {
                            Authorities.hasParameters(authorities) ? (
                                <li className="nav-item">
                                    <Link className="nav-link" to="/parametros">
                                        <ICON_TABLE className="fa-fw" />
                                        <span>Parámetros</span>
                                    </Link>
                                </li>
                            ) : null
                        }

                        {
                            Authorities.hasAdmin(authorities) ? (
                                <li className="nav-item">
                                    <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseAdmins" aria-expanded="true" aria-controls="collapseAdmins">
                                        <ICON_CONFIG className="fa-fw" />
                                        <span>Admin</span>
                                    </a>
                                    <div id="collapseAdmins" className="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
                                        <div className="bg-white py-2 collapse-inner rounded">
                                            <h6 className="collapse-header">Acceso:</h6>
                                            {
                                                Authorities.hasPermission(authorities, USUARIOS_LISTAR) ? (
                                                    <Link className="collapse-item" to="/administracion/usuarios">
                                                        Usuarios
                                                    </Link>
                                                ) : null
                                            }

                                            {
                                                Authorities.hasPermission(authorities, NIVELES_MODIFICAR) ? (
                                                    <Link className="collapse-item" to="/administracion/niveles">
                                                        Niveles
                                                    </Link>
                                                ) : null
                                            }
                                            
                                            <div className="collapse-divider"></div>

                                            <h6 className="collapse-header">Sistema:</h6>
                                            {
                                                Authorities.hasPermission(authorities, OFIJUS_LISTAR) ? (
                                                    <Link className="collapse-item" to="/administracion/ofijus">
                                                        Ofijus
                                                    </Link>
                                                ) : null
                                            }

                                            {
                                                Authorities.hasPermission(authorities, UNIDADES_LISTAR) ? (
                                                    <Link className="collapse-item" to="/administracion/unidades">
                                                        Unidades
                                                    </Link>
                                                ) : null
                                            }
                                            
                                        </div>
                                    </div>
                                </li>
                            ) : null
                        }

                        

                        <hr className="sidebar-divider d-none d-md-block" />
                    </React.Fragment>
                ) : null
            }            

            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle" onClick={handleExpand}></button>
            </div>

        </ul>
    );
};

export default SideBar;